module.exports = __webpack_public_path__ + "static/media/firearm.4d11c40e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/firearm.svg
// module id = 3068
// module chunks = 0